import { getDesign } from '../../DesignSystem';
export function getDefaultZoomUI() {
    const design = getDesign();
    const defaultZoomUI = {
        color: design.color,
        semantic: design.semantic,
        typography: design.typography,
        breakpoints: design.breakpoints,
        shadow: design.shadow,
        zIndex: design.zIndex,
    };
    return defaultZoomUI;
}
